// @flow

import type {EventHandler} from 'redux/middleware/googleTagManager/types';

import {EVENT_COPY_VOUCHER} from 'redux/middleware/googleTagManager/actionTypes';

type Event = {
  event: string,
  event_action: string,
  non_interaction: boolean,
};

export const action: () => {type: string} = () => ({
  type: EVENT_COPY_VOUCHER,
});

export const handler: EventHandler<() => {type: string}, Event> = (_) => ({
  event: 'checkout',
  event_action: 'users_voucher_copy_clicked',
  non_interaction: false,
});
